export default {
  pt: {
    'pedagios.excel.passagens': 'As passagens do período filtrado inteiro, com o vínculo e os eixos.',
    'pedagios.excel.passagensVazio': 'Nenhuma passagem no recorte para baixar.',
    'pedagios.aba.anomalias': 'Anomalias',
    'pedagios.aba.pracas': 'Praças',
    'pedagios.divergencia.eixo_nao_levantado': 'Eixo não levantado',
    'pedagios.eixos.fonte.estimativa': 'esperado vazio estimado com 1 eixo levantável por carreta',
    'pedagios.filtro.fornecedor': 'Fornecedor',
    'pedagios.filtro.tipo': 'Tipo de anomalia',
    'pedagios.filtro.praca': 'Praça',
    'pedagios.filtro.buscaPraca': 'Praça ou concessionária',
    'pedagios.fornecedor.edenred': 'Edenred',
    'pedagios.fornecedor.repom': 'Repom',

    'pedagios.anomalias.titulo': 'Anomalias de eixos',
    'pedagios.anomalias.ajuda': 'Eixo não levantado: o veículo ia vazio, com carreta, e pagou acima do esperado com os eixos levantados. Sem o cadastro dos levantáveis, vale 1 por carreta. Eixos impossíveis: cobrou mais eixos do que a composição tem; o cavalo sem cadastro conta 3. Abaixo carregado: o veículo ia carregado e passou com menos eixos que o esperado. O valor é o custo por eixo da passagem vezes a diferença.',
    'pedagios.anomalias.kpi.total': 'Anomalias',
    'pedagios.anomalias.kpi.aMais': 'Valor a mais',
    'pedagios.anomalias.kpi.aMaisHint': 'Eixo não levantado e eixos impossíveis, pelo custo por eixo de cada passagem',
    'pedagios.anomalias.porDia': 'Anomalias por dia',
    'pedagios.anomalias.porTipo': 'Por tipo',
    'pedagios.anomalias.centro': 'anomalias',
    'pedagios.anomalias.vazioGrafico': 'Nenhuma anomalia no período.',
    'pedagios.anomalias.topPlacas': 'Placas com mais anomalias',
    'pedagios.anomalias.topPracas': 'Praças com mais anomalias',
    'pedagios.anomalias.nAnomalias': '{{n}} anomalias',
    'pedagios.anomalias.umaAnomalia': '1 anomalia',
    'pedagios.anomalias.vazio': 'Nenhuma anomalia de eixo no recorte.',
    'pedagios.anomalias.col.veiculo': 'Veículo',
    'pedagios.anomalias.col.praca': 'Praça',
    'pedagios.anomalias.col.passagem': 'Passagem',
    'pedagios.anomalias.col.condicao': 'Condição',
    'pedagios.anomalias.col.eixos': 'Eixos',
    'pedagios.anomalias.col.tipo': 'Anomalia',
    'pedagios.anomalias.col.valor': 'Valor',
    'pedagios.anomalias.eixos.cobrados': 'Cobrados',
    'pedagios.anomalias.eixos.esperados': 'Esperados',
    'pedagios.anomalias.eixos.vazio': 'Vazio',
    'pedagios.anomalias.eixos.teto': 'Teto',
    'pedagios.anomalias.custo': 'Custo da passagem',
    'pedagios.anomalias.aMais': 'Valor da anomalia',
    'pedagios.anomalias.estimativa': 'Estimativa',
    'pedagios.anomalias.cliente': 'Cliente',
    'pedagios.anomalias.excel': 'As anomalias do período filtrado inteiro, com a composição e os eixos.',
    'pedagios.anomalias.excelVazio': 'Nenhuma anomalia no recorte para baixar.',

    'pedagios.pracas.ajuda': 'As praças saem das passagens, juntando o mesmo nome de praça e concessionária. A coordenada é a mediana das posições do rastreador do veículo a até 10 minutos da passagem. Os valores por eixo são a mediana dos últimos 90 dias e não seguem o período do filtro.',
    'pedagios.pracas.kpi.pracas': 'Praças',
    'pedagios.pracas.kpi.comCoordenada': 'Com coordenada',
    'pedagios.pracas.col.praca': 'Praça',
    'pedagios.pracas.col.passagens': 'Passagens',
    'pedagios.pracas.col.valores': 'Valor por eixos',
    'pedagios.pracas.col.coordenada': 'Coordenada',
    'pedagios.pracas.col.ultima': 'Última passagem',
    'pedagios.pracas.eixosN': '{{n}} eixos',
    'pedagios.pracas.valorDica': '{{n}} passagens nos últimos 90 dias, último valor {{ultimo}}',
    'pedagios.pracas.amostras': 'Mediana de {{n}} posições do rastreador',
    'pedagios.pracas.semCoordenada': 'Sem posição',
    'pedagios.pracas.semValor': 'Sem valor recente',
    'pedagios.pracas.vazio': 'Nenhuma praça montada ainda.',
    'pedagios.pracas.excel': 'Todas as praças do filtro, com a mediana por quantidade de eixos.',
    'pedagios.pracas.excelVazio': 'Nenhuma praça para baixar.',
  },
  en: {
    'pedagios.excel.passagens': 'The passages of the whole filtered period, with the link and the axles.',
    'pedagios.excel.passagensVazio': 'No passages in this range to download.',
    'pedagios.aba.anomalias': 'Anomalies',
    'pedagios.aba.pracas': 'Toll plazas',
    'pedagios.divergencia.eixo_nao_levantado': 'Axle not lifted',
    'pedagios.eixos.fonte.estimativa': 'empty expected estimated with 1 liftable axle per trailer',
    'pedagios.filtro.fornecedor': 'Provider',
    'pedagios.filtro.tipo': 'Anomaly type',
    'pedagios.filtro.praca': 'Toll plaza',
    'pedagios.filtro.buscaPraca': 'Plaza or concessionaire',
    'pedagios.fornecedor.edenred': 'Edenred',
    'pedagios.fornecedor.repom': 'Repom',

    'pedagios.anomalias.titulo': 'Axle anomalies',
    'pedagios.anomalias.ajuda': 'Axle not lifted: the vehicle was empty, with a trailer, and paid above the expected with the lift axles up. Without the liftable axles in the registry, 1 per trailer applies. Impossible axles: charged more axles than the combination has; a tractor without registry counts 3. Below while loaded: the vehicle was loaded and passed with fewer axles than expected. The amount is the cost per axle of the passage times the difference.',
    'pedagios.anomalias.kpi.total': 'Anomalies',
    'pedagios.anomalias.kpi.aMais': 'Overpaid',
    'pedagios.anomalias.kpi.aMaisHint': 'Axle not lifted and impossible axles, by the cost per axle of each passage',
    'pedagios.anomalias.porDia': 'Anomalies per day',
    'pedagios.anomalias.porTipo': 'By type',
    'pedagios.anomalias.centro': 'anomalies',
    'pedagios.anomalias.vazioGrafico': 'No anomalies in the period.',
    'pedagios.anomalias.topPlacas': 'Plates with most anomalies',
    'pedagios.anomalias.topPracas': 'Plazas with most anomalies',
    'pedagios.anomalias.nAnomalias': '{{n}} anomalies',
    'pedagios.anomalias.umaAnomalia': '1 anomaly',
    'pedagios.anomalias.vazio': 'No axle anomalies in this range.',
    'pedagios.anomalias.col.veiculo': 'Vehicle',
    'pedagios.anomalias.col.praca': 'Plaza',
    'pedagios.anomalias.col.passagem': 'Passage',
    'pedagios.anomalias.col.condicao': 'Condition',
    'pedagios.anomalias.col.eixos': 'Axles',
    'pedagios.anomalias.col.tipo': 'Anomaly',
    'pedagios.anomalias.col.valor': 'Amount',
    'pedagios.anomalias.eixos.cobrados': 'Charged',
    'pedagios.anomalias.eixos.esperados': 'Expected',
    'pedagios.anomalias.eixos.vazio': 'Empty',
    'pedagios.anomalias.eixos.teto': 'Ceiling',
    'pedagios.anomalias.custo': 'Passage cost',
    'pedagios.anomalias.aMais': 'Anomaly amount',
    'pedagios.anomalias.estimativa': 'Estimate',
    'pedagios.anomalias.cliente': 'Customer',
    'pedagios.anomalias.excel': 'Anomalies of the whole filtered period, with the combination and the axles.',
    'pedagios.anomalias.excelVazio': 'No anomalies in this range to download.',

    'pedagios.pracas.ajuda': 'Plazas come from the passages, joining the same plaza and concessionaire name. The coordinate is the median of the vehicle tracker positions within 10 minutes of the passage. Values per axle are the median of the last 90 days and do not follow the filter period.',
    'pedagios.pracas.kpi.pracas': 'Plazas',
    'pedagios.pracas.kpi.comCoordenada': 'With coordinate',
    'pedagios.pracas.col.praca': 'Plaza',
    'pedagios.pracas.col.passagens': 'Passages',
    'pedagios.pracas.col.valores': 'Amount per axles',
    'pedagios.pracas.col.coordenada': 'Coordinate',
    'pedagios.pracas.col.ultima': 'Last passage',
    'pedagios.pracas.eixosN': '{{n}} axles',
    'pedagios.pracas.valorDica': '{{n}} passages in the last 90 days, last amount {{ultimo}}',
    'pedagios.pracas.amostras': 'Median of {{n}} tracker positions',
    'pedagios.pracas.semCoordenada': 'No position',
    'pedagios.pracas.semValor': 'No recent amount',
    'pedagios.pracas.vazio': 'No plazas built yet.',
    'pedagios.pracas.excel': 'All plazas of the filter, with the median per number of axles.',
    'pedagios.pracas.excelVazio': 'No plazas to download.',
  },
  es: {
    'pedagios.excel.passagens': 'Los pasajes de todo el período filtrado, con el vínculo y los ejes.',
    'pedagios.excel.passagensVazio': 'Ningún pasaje en el recorte para descargar.',
    'pedagios.aba.anomalias': 'Anomalías',
    'pedagios.aba.pracas': 'Plazas',
    'pedagios.divergencia.eixo_nao_levantado': 'Eje no levantado',
    'pedagios.eixos.fonte.estimativa': 'esperado vacío estimado con 1 eje levantable por remolque',
    'pedagios.filtro.fornecedor': 'Proveedor',
    'pedagios.filtro.tipo': 'Tipo de anomalía',
    'pedagios.filtro.praca': 'Plaza',
    'pedagios.filtro.buscaPraca': 'Plaza o concesionaria',
    'pedagios.fornecedor.edenred': 'Edenred',
    'pedagios.fornecedor.repom': 'Repom',

    'pedagios.anomalias.titulo': 'Anomalías de ejes',
    'pedagios.anomalias.ajuda': 'Eje no levantado: el vehículo iba vacío, con remolque, y pagó encima de lo esperado con los ejes levantados. Sin el registro de los levantables, vale 1 por remolque. Ejes imposibles: cobró más ejes de los que tiene la composición; el tractor sin registro cuenta 3. Debajo cargado: el vehículo iba cargado y pasó con menos ejes de lo esperado. El valor es el costo por eje del pasaje por la diferencia.',
    'pedagios.anomalias.kpi.total': 'Anomalías',
    'pedagios.anomalias.kpi.aMais': 'Valor de más',
    'pedagios.anomalias.kpi.aMaisHint': 'Eje no levantado y ejes imposibles, por el costo por eje de cada pasaje',
    'pedagios.anomalias.porDia': 'Anomalías por día',
    'pedagios.anomalias.porTipo': 'Por tipo',
    'pedagios.anomalias.centro': 'anomalías',
    'pedagios.anomalias.vazioGrafico': 'Ninguna anomalía en el período.',
    'pedagios.anomalias.topPlacas': 'Placas con más anomalías',
    'pedagios.anomalias.topPracas': 'Plazas con más anomalías',
    'pedagios.anomalias.nAnomalias': '{{n}} anomalías',
    'pedagios.anomalias.umaAnomalia': '1 anomalía',
    'pedagios.anomalias.vazio': 'Ninguna anomalía de ejes en el recorte.',
    'pedagios.anomalias.col.veiculo': 'Vehículo',
    'pedagios.anomalias.col.praca': 'Plaza',
    'pedagios.anomalias.col.passagem': 'Pasaje',
    'pedagios.anomalias.col.condicao': 'Condición',
    'pedagios.anomalias.col.eixos': 'Ejes',
    'pedagios.anomalias.col.tipo': 'Anomalía',
    'pedagios.anomalias.col.valor': 'Valor',
    'pedagios.anomalias.eixos.cobrados': 'Cobrados',
    'pedagios.anomalias.eixos.esperados': 'Esperados',
    'pedagios.anomalias.eixos.vazio': 'Vacío',
    'pedagios.anomalias.eixos.teto': 'Techo',
    'pedagios.anomalias.custo': 'Costo del pasaje',
    'pedagios.anomalias.aMais': 'Valor de la anomalía',
    'pedagios.anomalias.estimativa': 'Estimación',
    'pedagios.anomalias.cliente': 'Cliente',
    'pedagios.anomalias.excel': 'Las anomalías de todo el período filtrado, con la composición y los ejes.',
    'pedagios.anomalias.excelVazio': 'Ninguna anomalía en el recorte para descargar.',

    'pedagios.pracas.ajuda': 'Las plazas salen de los pasajes, juntando el mismo nombre de plaza y concesionaria. La coordenada es la mediana de las posiciones del rastreador del vehículo hasta 10 minutos del pasaje. Los valores por eje son la mediana de los últimos 90 días y no siguen el período del filtro.',
    'pedagios.pracas.kpi.pracas': 'Plazas',
    'pedagios.pracas.kpi.comCoordenada': 'Con coordenada',
    'pedagios.pracas.col.praca': 'Plaza',
    'pedagios.pracas.col.passagens': 'Pasajes',
    'pedagios.pracas.col.valores': 'Valor por ejes',
    'pedagios.pracas.col.coordenada': 'Coordenada',
    'pedagios.pracas.col.ultima': 'Último pasaje',
    'pedagios.pracas.eixosN': '{{n}} ejes',
    'pedagios.pracas.valorDica': '{{n}} pasajes en los últimos 90 días, último valor {{ultimo}}',
    'pedagios.pracas.amostras': 'Mediana de {{n}} posiciones del rastreador',
    'pedagios.pracas.semCoordenada': 'Sin posición',
    'pedagios.pracas.semValor': 'Sin valor reciente',
    'pedagios.pracas.vazio': 'Ninguna plaza armada todavía.',
    'pedagios.pracas.excel': 'Todas las plazas del filtro, con la mediana por cantidad de ejes.',
    'pedagios.pracas.excelVazio': 'Ninguna plaza para descargar.',
  },
}
